<template>
  <div style="display:flex;">
    <div
      class="p-1 column50 border border-right-0 bg-dark text-white"
      style="height: auto"
    >
      {{ title }}
    </div>
    <div
      class="p-1 column50 border border-left-0 bg-dark text-white"
      style="height: auto"
    >
      {{ subtitle }}
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'subtitle'],
}
</script>
